import { type RouteRecordRaw } from 'vue-router';

export const publicRoutes: RouteRecordRaw[] = [
    {
        path: "/login",
        name: "login",
        component: () => import("./pages/Login.vue"),
        meta: { guestOnly: true, title: "auth.title" },
    },
    {
        path: "/auth/microsoft/complete",
        name: "microsoft-complete",
        component: () => import("./pages/MicrosoftComplete.vue"),
        meta: { title: "auth.microsoft_login" },
    }
];

export const protectedRoutes: RouteRecordRaw[] = [
    {
        path: "/profile",
        name: "profile",
        component: () => import("./pages/UserDetail.vue"),
        meta: { title: "menu.profile" },
    },
    {
        path: "/users",
        name: "users",
        component: () => import("./pages/UserList.vue"),
        meta: { role: 'admin', title: "users.title" }
    },
    {
        path: "/users/create",
        name: "users-create",
        component: () => import("./pages/UserForm.vue"),
        meta: { role: 'admin', title: "users.create" }
    },
    {
        path: "/users/:id",
        name: "users-detail",
        component: () => import("./pages/UserDetail.vue"),
        meta: { title: "users.detail" },
    },
    {
        path: "/users/:id/edit",
        name: "users-edit",
        component: () => import("./pages/UserForm.vue"),
        meta: { title: "users.edit" },
    }
];
